import ProductSubscriptionsReducer from "@aihCustomBlueprint/Store/Data/AihCustomProductSubscribe/ProductSubscribeReducer";
import GiftCardReducer from "@aihCustomBlueprint/Store/Data/GiftCard/GiftCardReducer";
import ReviewCartLineReducer from "@aihCustomBlueprint/Store/Data/ReviewCartLine/ReviewCartLineReducer";
import { combineReducers } from "redux";

const customReducers = {
    GiftCards: GiftCardReducer,
    ReviewCartLines: ReviewCartLineReducer,
    ProductSubscriptions: ProductSubscriptionsReducer,
};

export type CustomDataReducers = typeof customReducers;

const customDataReducer = combineReducers(customReducers as any);

export default customDataReducer;
